export default {
  title: {
    type: 'string',
    default: '',
  },
  description: {
    type: 'string',
    default: '',
  },
  target: {
    type: 'boolean',
    default: true,
  },
  nameButton: {
    type: 'string',
    default: '',
  },
};
